import React from "react";
import { dateFormat } from "../../../helper/dateConvertor";
import { numberNotation } from "../../../helper/numberStructure";
import "./CardCollegePublic.scss";

const CardCollegePublic = ({ course }) => {
  const paymenDue = () => {
    if (course) {
      const paymentOnDue = course.total - course.firstPayment;
      return paymentOnDue;
    }
    return "";
  };

  const duePayment = paymenDue();

  return (
    <>
      {course && (
        <div className="card-item-content">
          <h2 className="title-gray-bold-22 card__sub-title">{course.name}</h2>
          <div className="content-info paragraph-gray-reg-20">
            <span>{dateFormat(course.startDate)}</span>
            <span>{dateFormat(course.endDate)}</span>
          </div>
          <div className="content-info">
            <span className="paragraph-gray-reg-20">Duration</span>
            <span className="paragraph-gray-bold-20">
              {course.duration} weeks
            </span>
          </div>

          <div className="content-info">
            <span className="paragraph-gray-reg-20">Tuition</span>
            <span className="paragraph-gray-bold-20">
              A$ {numberNotation(course.tuitionfee)}
            </span>
          </div>
          <div className="content-info">
            <span className="paragraph-gray-reg-20">Material</span>
            <span className="paragraph-gray-bold-20">
              A$ {numberNotation(course.material)}
            </span>
          </div>
          <div className="content-info">
            <span className="paragraph-gray-reg-20">Application</span>
            <span className="paragraph-gray-bold-20">
              A$ {numberNotation(course.applicationfee)}
            </span>
          </div>
          <div className="content-info">
            <span className="paragraph-gray-reg-20">First Payment</span>
            <span className="paragraph-gray-bold-20">
              A$ {numberNotation(course.firstPayment)}
            </span>
          </div>

          <div className="content-info">
            <span className="paragraph-gray-reg-20">First Payment at</span>
            <span className="paragraph-gray-bold-20">
              {
                dateFormat(course.dateFirstPayment)
              }
            </span>
          </div>
          <div className="content-info">
            <span className="paragraph-gray-reg-20">Payment Due</span>
            <span className="paragraph-gray-bold-20">
              A$ {numberNotation(duePayment)}
            </span>
          </div>
          <div className="content-info shadow-bg">
            <span className="paragraph-gray-reg-20">Total Course</span>
            <span className="paragraph-gray-bold-20">
              A$ {numberNotation(course.total)}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default CardCollegePublic;
